import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles, ArrowRight, X } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

// Sticky floating CTA (desktop only) that appears once user scrolls past the hero.
// Hidden on mobile (it would cover the text) and on /contact and admin routes.
export default function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith("/admin")) return null;
  if (pathname.startsWith("/contact")) return null;
  if (!visible || dismissed) return null;

  return (
    <div
      data-testid="sticky-cta"
      className="hidden sm:inline-flex fixed bottom-6 right-6 z-40 items-center rounded-full bg-blue-600 text-white shadow-xl shadow-black/20 border border-[#C5A880]/25 transition-all hover:-translate-y-0.5"
    >
      <Link to="/contact" className="inline-flex items-center gap-2 pl-4 pr-2 py-2.5 sm:px-5 sm:py-3">
        <Sparkles className="w-4 h-4" />
        <span className="text-xs sm:text-sm font-medium">{t("sticky")}</span>
        <ArrowRight className="w-4 h-4" />
      </Link>
      <button
        data-testid="sticky-cta-close"
        onClick={() => setDismissed(true)}
        aria-label="Fermer"
        className="mr-1.5 sm:mr-2 p-1.5 rounded-full hover:bg-white/20 transition-colors"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
